/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Update_LaterInputs */

const en_us2_profile_update_later = /** @type {(inputs: Profile_Update_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const pt_br2_profile_update_later = /** @type {(inputs: Profile_Update_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depois`)
};

const es_419_profile_update_later = /** @type {(inputs: Profile_Update_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Después`)
};

const pt_pt2_profile_update_later = /** @type {(inputs: Profile_Update_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depois`)
};

const fr_fr2_profile_update_later = /** @type {(inputs: Profile_Update_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus tard`)
};

const de_de2_profile_update_later = /** @type {(inputs: Profile_Update_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Später`)
};

const it_it2_profile_update_later = /** @type {(inputs: Profile_Update_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dopo`)
};

/**
* | output |
* | --- |
* | "Later" |
*
* @param {Profile_Update_LaterInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_update_later = /** @type {((inputs?: Profile_Update_LaterInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Update_LaterInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_update_later(inputs)
	if (locale === "es-419") return es_419_profile_update_later(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_update_later(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_update_later(inputs)
	if (locale === "de-DE") return de_de2_profile_update_later(inputs)
	if (locale === "it-IT") return it_it2_profile_update_later(inputs)
	return en_us2_profile_update_later(inputs)
});
export { profile_update_later as "profile.update_later" }